/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { COMMON_LOGIN_MODAL } from '@spotahome/ui-library/src/tenant/components/utils/constants';

import './FavoriteMessage.scss';

const handleModalOpen = () => {
  Mediator.publish(COMMON_LOGIN_MODAL, {
    initialAction: 'signup'
  });
};

const FavoriteMessageLogged = () => (
  <div>
    <p
      onClick={handleModalOpen}
      dangerouslySetInnerHTML={{
        __html: trans('favorites.message.top.not_logged')
      }}
      className="favorites--message ga-favorites-page-explore-button"
    />
  </div>
);

export default FavoriteMessageLogged;
